import React, { useEffect, useState } from "react";
import {formatTextWithLineBreaks, MakeAxiosRequest} from "../../../utils/handler";
import { Link, useNavigate } from "react-router-dom";
import { switchProfile } from "../../../features/authSlice";
import { useDispatch } from "react-redux";
import Loader from "../../../Components/loader/Loader";
import { ModalContentWithData, ModalHeader } from "../DetailsModal";
import { SwalError } from "../../../Components/SwalFns";
import { InfoModal} from "../../../Components/modals/InfoModal";
import UpdateInfoModal from "./UpdateInfoModal";

function ViewRelationshipDetail({
  closeModal,
  proxyKey,
  proxyType,
  editFn,
  deleteFn,
  changeView,
  isLoading,
  setIsLoading,
  listingFn,
  isProfile
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [response, setResponse] = useState({});
  const [userData, setUserData] = useState({});
  const [updateInfoType, setUpdateInfoType] = useState('');

  const fetchData = async () => {
    try {
      response || setIsLoading({ modal: true, content: true });
      const res = await MakeAxiosRequest("post", isProfile ? "customerdetails" : "relationdetails", {
        user_proxy_key: proxyKey,
        user_proxy_type: proxyType,
      });
      if (res.name !== "CanceledError" && res.status == 1) {
        setResponse(res.data);
        setUserData(isProfile ? res.data.customerdetails : res.data.proxydata)
        setIsLoading({ modal: false, content: false });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading({ modal: false, content: false });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const triggerMenu = (type) => {
    closeModal();
    switch (type) {
      case "edit":
        editFn(proxyKey);
        break;
      case "delete":
        deleteFn(proxyKey);
        break;
    }
  };

  const orderService = () => {
    dispatch(switchProfile({ key: proxyKey, type: proxyType }));
    navigate("/dashboard");
  };

  const toggleAcountSettings = async (url, value) => {
    try {
      const res = await MakeAxiosRequest("post", url, {
        user_proxy_key: proxyKey,
        is_checked: value,
      });
      if (res.status == 1) {
        fetchData();
        listingFn();
      } else {
        SwalError({ msg: res.message });
      }
    } catch (error) {
      console.error("Error :", error);
    }
  };

  const maxineStarInfo = [
    {
      type: "additional",
      text: "Account Information",
      isShow: !isProfile,
      isEditable: response.is_show_accountinfo_edit==1,
      fields: [
        {
          type: "Email",
          value: userData?.email,
        },
        {
          type: "Phone Number",
          value: userData?.phone_number
        },
      ],
    },
    {
      type: "contact",
      text: "Contact Information",
      isShow: !isProfile,
      isEditable: true,
      fields: [
        {
          type: "Contact Person",
          value: userData?.responsible_party,
        },
        {
          type: "Service Address",
          value: userData?.formatted_address,
        }
      ],
    },
    {
      type: "contact",
      text: "Contact Information",
      isShow: !!isProfile,
      isEditable: true,
      fields: [
        {
          type: "Contact Person",
          value: userData?.responsible_party,
        },
        {
          type: "Service Address",
          value: userData?.formatted_address,
        },
        {
          type: "Email",
          value: userData?.email,
        },
        {
          type: "Phone Number",
          value: userData?.phone_number
        }
      ],
    },
    {
      type: "home",
      text: "Home Information",
      isShow: true,
      isEditable: true,
      fields: [
        {
          type: "How many people are in the household?",
          value: userData?.peoples_in_house_hold,
        },
        {
          type: "Home Type Family",
          value: userData?.home_type,
        },
        {
          type: "Pets",
          value: userData?.pet,
        },
      ],
    },
    {
      type: "personal",
      text: "Personal Information",
      isShow: true,
      isEditable: true,
      fields: [
        {
          type: "Where did they grow up?",
          value: userData?.grow_up,
        },
        {
          type: "Occupation and/or Retired",
          value: userData?.occupation,
        },
        {
          type: "Veteran",
          value: userData?.veteran,
        },
        {
          type: "Likes",
          value: userData?.likes,
        },
        {
          type: "Anything else?",
          value: userData?.anything_else,
        },
      ],
    },
    {
      type: "medical",
      text: "Medical Information",
      isShow: true,
      isEditable: true,
      fields: userData?.medical_information,
    },
  ];

  if (isLoading.modal) return <Loader />;
  return (
    <>
      <ModalHeader
        title="Relationship"
        menuarray={response.menuarray}
        triggerMenu={triggerMenu}
      />

      <ModalContentWithData proxydata={userData}>
        <div className="col-12 mt-4 rltnshp-body">
          {response.accountPermission?.is_show_permission == 1 && (
            <div className="d-flex align-items-center justify-content-center">
              <a className="btn btn-border px-4 py-2" onClick={changeView}>
                <span className="material-symbols-outlined ">encrypted</span>
                {response.accountPermission?.permission_text ||
                  "Account Permissions"}
                <span className="count text-white ms-3">
                  {response.accountPermission?.count || "0"}
                </span>
              </a>
            </div>
          )}

          <div className="row mb-2 mt-5">
            {/* {response.walletpermissiondetails?.payment_permission_enabled ==
              1 && (
              <>
                <div className="col-6">
                  <p>Payment Permissions </p>
                </div>
                <div className="col-6 text-end">
                  <p className="d-flex align-items-center justify-content-end verified">
                    {response.walletpermissiondetails?.permission_label ===
                      "Enabled" && (
                      <span className="material-symbols-outlined me-2">
                        new_releases
                      </span>
                    )}
                    {response.walletpermissiondetails?.permission_label}
                  </p>
                </div>
              </>
            )} */}
            {/* {response.walletpermissiondetails?.is_show_role == 1 && (
              <>
                <div className="col-md-6 text-center text-md-start">
                  <p className="mb-0">
                    <strong>Role</strong>
                  </p>
                </div>
                <div className="col-md-6 text-center text-md-end">
                  <p className="d-flex align-items-center justify-content-center justify-content-md-end verified mb-0">
                    {response.walletpermissiondetails?.role || "- -"}
                  </p>
                </div>
              </>
            )} */}

            {/* {(response.show_maxine_star == "1" || !!isProfile ) && (
              <>
                <div className="col-6">
                  <p>
                    Enabled for Services(<i className="fa-solid fa-star"></i>){" "}
                    {response.infoMessages && <InfoModal {...response.infoMessages?.find(itm=>itm.type==='maxine_star')}/>}
                  </p>
                </div>
                <div className="col-6 d-flex justify-content-end align-items-center">
                  <label className="me-2">{userData?.maxine_star == "1" == "1" ? 'ON' : 'OFF'}</label>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input me-2"
                      type="checkbox"
                      role="switch"
                      id="paymentPermissionSwitch"
                      checked={userData?.maxine_star == "1"}
                      onChange={() =>
                        toggleAcountSettings(
                          isProfile ? "changecustomermaxinestar" : "changemaxinestar",
                          userData?.maxine_star == "1" ? "0" : "1"
                        )
                      }
                    />
                  </div>
                </div>
              </>
            )} */}
            {(response.show_maxine_star == "1" || !!isProfile ) && (
              <>
                <div className="col-6">
                  <p>
                    Enabled for Services(<i className="fa-solid fa-star"></i>){" "}
                    {response.infoMessages && <InfoModal {...response.infoMessages?.find(itm=>itm.type==='maxine_star')}/>}
                  </p>
                </div>
                <div className="col-6 d-flex justify-content-end align-items-center">
                  <label className="me-2">{userData?.maxine_star == "1" == "1" ? 'ON' : 'OFF'}</label>
                  <div>
                    <label className="switch">
                      <input 
                        type="checkbox" 
                        checked={userData?.maxine_star == "1"} 
                        onChange={() =>
                          toggleAcountSettings(
                            isProfile ? "changecustomermaxinestar" : "changemaxinestar",
                            userData?.maxine_star == "1" ? "0" : "1"
                          )
                        }
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              </>
            )}
            {response.show_paymemt_permission == "1" && (
              <>
                <div className="col-6">
                  <p>
                    Payment Permissions <InfoModal {...response.infoMessages.find(itm=>itm.type==='payment_permission')}/>
                  </p>
                </div>
                <div className="col-6 d-flex justify-content-end align-items-center">
                  <label className="me-2">{response.walletpermissiondetails?.payment_permission_enabled == "1" ? 'ON' : 'OFF'}</label>
                  <div>
                    <label className="switch">
                      <input 
                        type="checkbox" 
                        checked={response.walletpermissiondetails?.payment_permission_enabled == "1"}
                        onChange={() =>
                          toggleAcountSettings(
                            "changepaymentpermission",
                            response.walletpermissiondetails?.payment_permission_enabled == "1" ? "0": "1"
                          )
                        }
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              </>
            )}
          </div>

          {response.walletdetails?.is_show_wallet === 1 && (
            <div className="web-card wallet-card mb-3">
              <div className="row">
                <div className="col-sm-4 col-md-6 text-center text-sm-start mb-3 mb-sm-0">
                  <p className="mb-1">Wallet Balance</p>
                  <h3 className="mb-0">
                    {response.walletdetails?.wallet_balance || "$0.00"}
                  </h3>
                </div>
                {response.walletdetails?.is_show_gotowallet === 1 && (
                  <div className="col-sm-8 col-md-6 text-center text-sm-end">
                    <div className="position-relative">
                      <Link
                        className="btn btn-primary rounded-pill px-5 mb-2 py-2"
                        to={`/wallet/${userData?.user_proxy_key}`}
                      >
                        {response.walletdetails?.btn_label}
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </ModalContentWithData>
      <div className="row justify-content-center">
        
        {response.buttondetails?.show_button_title2 === 1 && (
          <div className="col-lg-4 col-md-4 col-12">
              <button
                type="button"
                className="btn btn-primary rounded-pill w-100 my-2 p-2"
                onClick={() =>
                  navigate(
                    `/servicerequests/${userData?.user_proxy_key}`
                  )
                }
              >
                {response.buttondetails?.button_title2}
              </button>
          </div>
        )}
        {response.buttondetails?.show_button_title1 === 1 && (
          <div className="col-lg-4 col-md-4 col-12">
              <button
                type="button"
                className="btn btn-tertiary rounded-pill w-100 my-2 p-2"
                onClick={() => orderService(userData?.user_proxy_key)}
              >
                {response.buttondetails?.button_title1}
              </button>
          </div>
        )}
      </div>

      <div>
        <div className="row mt-3 relation-view">
          {maxineStarInfo?.map((info, index) => (
            <React.Fragment key={index}>
              {info.isShow && (
                <div className="col-12">
                <>
                <div className="row">
                  <div className="col-12 mt-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <h4>{info.text}</h4>
                      {info.isEditable && <i className="fa-solid fa-pen me-2 edit-pen" onClick={()=>setUpdateInfoType(info.type)}></i>}
                    </div>
                  </div>
                  {info.fields.map((data, i) => (
                    <React.Fragment key={i}>
                      <div className="col-6">
                        <p>{data.type}</p>
                      </div>
                      <div className="col-6 text-end">
                        <p dangerouslySetInnerHTML={{__html: formatTextWithLineBreaks(data.value) }}></p>
                      </div>
                      {data.show_other_text=='1' && 
                        <div className="col-12">
                        <p className="border border-primary rounded p-3" dangerouslySetInnerHTML={{__html: formatTextWithLineBreaks(data.other_text) }}></p>
                      </div>}
                    </React.Fragment>
                  ))}
                  </div>
                </>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    {!!updateInfoType && 
      <UpdateInfoModal 
        showModal={!!updateInfoType}
        closeModal={() => setUpdateInfoType('')}
        type={updateInfoType}
        editKey={proxyKey}
        profileEdit={isProfile}
        listingFn={fetchData}
      />
    }

    </>
  );
}

export default ViewRelationshipDetail;
